import React, { useEffect }  from "react";
import { connect } from "react-redux";
import Card from "components/card";
import { Form } from 'antd';
import FarmParcelFields from "../../farmer-informations/components/FarmParcelFields";
import { 
	getFarmParcelDetails, doFarmParcelCreate, doFarmParcelUpdate 
} from "../../../../redux/farmparcel/farmParcelState";
import { useForm } from 'antd/lib/form/Form';
import CrudButtons from "components/button/crudbuttons";

const FarmParcelForm = ({getRecord, doCreate, doUpdate, recordData, requesting, success, ...props}) => {
	const { farmerId, recordId, mode } = props;  	
	const [form] = useForm();
	
	useEffect(() => {		
		getRecord(recordId);
	}, [recordId, getRecord]);
	
	useEffect(() => {
		if(recordData){
			const { address, ...restData } = recordData;
			const initialValues = {
				...Object.fromEntries(
					Object.entries(address || {}).map(([key, value]) => [`address_${key}`, value])
				),
				...restData
			};
			form.setFieldsValue(initialValues);
		}
	}, [recordData, form]);
	
	const onSubmit = (formData) => {	
		
		try {  	
			formData.farmerId = farmerId;		
			formData.within_ancestral_domain = formData.within_ancestral_domain === false ? 0 : (formData.within_ancestral_domain === true ? 1 : 0);
			formData.agrarian_reform_beneficiary = formData.agrarian_reform_beneficiary === false ? 0 : (formData.agrarian_reform_beneficiary === true ? 1 : 0);
			recordData.id > 0 ? doUpdate(formData): doCreate(formData); 
		} catch (error) {
			console.error('Save failed:', error);
		}
	};

	return (
		<Card extra={"w-full h-full p-4"}>
			<Form form={form} className="p-4 bg-white rounded-md dark:bg-intsamis-900"
				layout="vertical"
				onFinish={onSubmit}
			>   
				<FarmParcelFields recordData={recordData} mode={mode} form={form}/>

				<CrudButtons baseRoute={`/console/farmer-informations/${farmerId}/farm-parcels`}
					mode={mode} 
					recordId={recordId} 
					backUrl={`/console/farmer-informations/${farmerId}/view#farm_parcels`}
					cancelUrl={`/console/farmer-informations/${farmerId}/view#farm_parcels`}
					cancelLabel="Back"/>
			</Form>	 	
		</Card>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.farmParcel.details?.data,
	requesting: state.farmParcel.details?.requesting,
	success: state.farmParcel.details?.success,
});

const mapDispatchToProps = (dispatch) => ({
	getRecord: (id) => dispatch(getFarmParcelDetails(id)),
	doCreate: (data) => dispatch(doFarmParcelCreate(data)),
	doUpdate: (data) => dispatch(doFarmParcelUpdate(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(FarmParcelForm);